/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListHiredContractsResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'HiredContract',
        },
      },
    },
  }],
} as const;
